import { $request } from '@/utils/request';
import servers from '../servers';

/**
 * @description: 需求列表
 */
export function getRequirementList(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/list`,
    method: 'POST',
    data: params,
    CancelToken: true
  });
}
export function getRequirementListAll(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/list/all`,
    method: 'POST',
    data: params,
  });
}
/**
 * @description: 创建需求
 */
export function createRequirement(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement`,
    method: 'POST',
    data: params,
  });
}
/**
 * @description: 需求详情
 */
export function getRequirementDetail(param: any): any {
  return $request({
    url: `${servers.api}/v1/requirement?id=${param}`,
    method: 'get',
  });
}
/**
 * @description: 查询需求列表
 */
export function getRequirementType(): any {
  return $request({
    url: `${servers.api}/v1/requirement/type`,
    method: 'get',
  });
}

/**
 * @description: 查询 数据来源 列表
 */
export function getSourceSimple(): any {
  return $request({
    url: `${servers.api}/v1/source/simple`,
    method: 'get',
  });
}

/**
 * @description: 执行 sql 校验
 */
export function getSqlCheck(params?: any): any {
  return $request({
    url: `${servers.api}/v1/source/sql/check`,
    method: 'post',
    data: params,
  });
}

/**
 * @description: 执行 sql
 */
export function getExecuteSql(requirementId?: string, params?: any): any {
  return $request({
    url: `${servers.api}/v1/source/sql/execute/${requirementId}`,
    method: 'post',
    data:params
  });
}

/**
 * @description: 查询需求状态列表
 */
export function getRequirementState(): any {
  return $request({
    url: `${servers.api}/v1/requirement/state`,
    method: 'get',
  });
}

/**
 * @description: 创建需求
 */
export function updateRequirement(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/update`,
    method: 'POST',
    data: params,
  });
}

/**
 * @description: 方案交付-上传附件
 */
export function uploadDeliverableFiles(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/saveFile`,
    method: 'POST',
    data: params,
  });
}

/**
 * @description: 方案交付-删除附件
 */
export function removeDeliverableFiles(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/deleteFile`,
    method: 'POST',
    data: params,
  });
}

/**
 * @description: 下载文件流
 */
export function getDown(key:string): any {
  return $request({
    url: `${servers.api}/v1/common/downloadFile?ossKey=${key}`,
    method: 'get',
    responseType: 'blob',
    handledError: true,
  });
}

/**
 * @description: 指派
 */
export function getRequirementAssign(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/assign`,
    method: 'post',
    data: params,
  });
}

/**
 * @description: 列表受理
 */
export function getRequirementAccept(id?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/accept/${id}`,
    method: 'post',
  });
}
/**
 * @description: 受理
 */
export function acceptWithTypeChange(id: any, data: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/acceptWithTypeChange/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description: 关闭流程
 */
export function getCloseDemand(id?: any,params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/close/${id}`,
    method: 'post',
    data:params
  });
}

/**
 * @description: 修改当前的需求类型
 */
export function getUpdateRequirementType(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/updateType`,
    method: 'post',
    data:params
  });
}


/**
 * @description: 发起审批流
 */
export function getStartBpm(params?: any): any {
  return $request({
    url: `${servers.api}/v1/bpm/dataDownload`,
    method: 'post',
    data: params,
  });
}

/**
 * @description: 获取用户所属部门的业务总经理
 */
export function getDeptManager(username?: any): any {
  return $request({
    url: `${servers.api}/v1/bpm/getDeptManager/${username}`,
    method: 'get',
  });
}

/**
 * @description: 查询 提交审批的字段回显
 */
export function getBpmSubmitDetail(instanceId?: any): any {
  return $request({
    url: `${servers.api}/v1/bpm/dataDownload/${instanceId}/detail`,
    method: 'get',
  });
}

/**
 * @description: 校验
 */
export function getCheckPower(id?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/allowIntoGroup/${id}`,
    method: 'get',
  });
}


/**
 * @description: 知识库存储接口
 */
export function getSaveKnowledge(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/insertKnowledge`,
    method: 'post',
    data: params,
  });
}

/**
 * @description: 知识库查询
 */
export function getKnowledgeData(id?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/getKnowledge/${id}`,
    method: 'get',
  });
}

/**
 * @description: 查询 DBA 消息
 */
export function getExportWorkOrderDetail(id?: any): any {
  return $request({
    url: `${servers.api}/v1/itsm/getWorkOrderInfo/${id}`,
    method: 'get',
  });
}

/**
 * @description: DBA 导出
 */
export function getExportWorkOrder(params?: any): any {
  return $request({
    url: `${servers.api}/v1/itsm/createWorkOrder`,
    method: 'post',
    data: params
  });
}


/**
 * @description: 取消审批流程
 */
export function getCancel(params?: any): any {
  return $request({
    url: `${servers.api}/v1/bpm/terminate/${params}`,
    method: 'get',
  });
}

/**
 * @description: 查询 需求类型 - 需求详情
 */
export function getRequirementTypeDetail(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/${params}/supplement`,
    method: 'get',
  });
}

/**
 * @description: 修改 需求类型 - 需求详情
 */
export function updateRequirementTypeDetail(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/${params.id}/supplement`,
    data:params.data,
    method: 'put',
  });
}

/**
 * @description: 知识检索
 */
export function searchKnowledge(params?: any): any {
  return $request({
    url: `${servers.api}/v1/requirement/similar`,
    method: 'get',
    params,
  });
}
/**
 * @description: 对应项目可选角色
 */
export function getProjectManage(params?: any): any {
  return $request({
    url: `${servers.api}/v1/getProjectManage`,
    method: 'post',
    data: params
  });
}
/**
 * @description: 新建可选角色
 */
export function getOperationUsers(params?: any): any {
  return $request({
    url: `${servers.api}/v1/getDevelopUsers`,
    method: 'post',
    data: params
  });
}

